/**
 * Galerie photos immeuble : buildingImageUrls[] avec repli sur buildingImageUrl (legacy).
 */

export function getBuildingImageGallery(property) {
  const urls = property?.buildingImageUrls;
  if (Array.isArray(urls) && urls.length) {
    return urls
      .map((u) => (typeof u === 'string' ? u.trim() : ''))
      .filter((u) => /^https?:\/\//i.test(u));
  }
  const single = String(property?.buildingImageUrl || '').trim();
  return single && /^https?:\/\//i.test(single) ? [single] : [];
}

/** Au moins une URL de galerie valide (pour éviter d’écraser Firestore avec [] par erreur). */
export function propertyHasGalleryImages(property) {
  return getBuildingImageGallery(property).length > 0;
}

export function getPrimaryBuildingImageUrl(property) {
  const g = getBuildingImageGallery(property);
  return g[0] || '';
}
